import { ICategory, IItem } from './../../models/item.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { IPagination } from 'src/app/common/model/util.model';

@Injectable({
  providedIn: 'root'
})
export class ItemCategoryService {
  constructor(private http: HttpClient) {}

  // category
  public addCategory(category: any) {
    return this.http.post(`${environment.api_url}pos/category`, category);
  }
  public getCategories(): Observable<ISibasiHTTPResponse<ICategory[]>> {
    return this.http.get<ISibasiHTTPResponse<ICategory[]>>(
      `${environment.api_url}pos/category`
    );
  }
  public getCategory(categoryId: any): Observable<ISibasiHTTPResponse<ICategory>> {
    return this.http.get<ISibasiHTTPResponse<ICategory>>(
      `${environment.api_url}pos/category/${categoryId}`
    );
  }

  getPaginatedCategories(
    pagination?: any
  ): Observable<ISibasiHTTPResponse<IPagination<ICategory[]>>> {
    return this.http.post<ISibasiHTTPResponse<IPagination<ICategory[]>>>(
      `${environment.api_url}pos/category/get/paginated`,
      pagination ? pagination : {}
    );
  }

  public editCategory(categoryId: any, category: {}) {
    return this.http.post(`${environment.api_url}pos/category/${categoryId}`, category);
  }
  public getFilteredItemsByCategory(
    categoryId: any
  ): Observable<ISibasiHTTPResponse<{ items: IItem[]; name: string; _id: string }>> {
    return this.http.get<
      ISibasiHTTPResponse<{ items: IItem[]; name: string; _id: string }>
    >(`${environment.api_url}pos/category/all/items/${categoryId}`);
  }

  public categoryItems(categoryId: any) {
    return this.http.get(
      `${environment.api_url}pos/item/numberOfItemsInCategory/${categoryId}`
    );
  }

  public deleteCategory(categoryId: any) {
    return this.http.delete(`${environment.api_url}pos/category/${categoryId}`);
  }
}
